import React from 'react';
import DillardsLogo from './svgs/DillardsLogo';
import CloseIcon from './svgs/CloseIcon';
import FeedbackQuestionOptions from './FeedbackQuestionOptions';

const PopUpSurveyForm = ({
  handleResetModal,
  hover,
  handleHover,
  selectedState,
  selectedTemplate,
  handleSelectState,
  loading,
  error,
  errorMessage,
  handleSubmitFeedback,
  handleInput,
  handleSelectYoN,
  submitSuccess,
  attemptedSubmit,
  siteFormat,
  answersObj,
  showInviteView,
  handleInviteResponse,
}) => {
  return (
    <div id={`feedback_form_content`} className={`${siteFormat === 'mobile' && 'mobile'} row mx-0`}>
      <CloseIcon handleResetModal={handleResetModal} siteFormat={siteFormat} />
      {submitSuccess ? (
        <>
          <div id='feedback_success_content'>
            <div id='feedback_success_title'>Thank you!</div>
            <div id='feedback_success_message'>
              We appreciate you taking the time to help make your shopping experience the best it can be.
            </div>
            <button className='btn btn-primary btn-block' id='feedback_submit' onClick={() => handleResetModal()}>
              Continue Shopping
            </button>
          </div>
        </>
      ) : (
        <>
          <div id='feedback_form_header'>
            <DillardsLogo />
          </div>
          <div id='popup_survey_form_body' className='col-12'>
            {showInviteView ? (
              <div id='popUpSurveyInit'>
                <h2>Would you like to provide quick feedback?</h2>
                <p>(It will only take a minute)</p>
                <div id='popup_survey_buttons_section'>
                  <button
                    className='btn btn-primary btn-block'
                    id='feedback_submit'
                    onClick={(e) => handleInviteResponse(e)}
                  >
                    Yes
                  </button>
                  <button className='btn btn-secondary btn-block' onClick={() => handleResetModal()}>
                    No thanks
                  </button>
                </div>
              </div>
            ) : loading ? (
              <div id='loading_spinner_holder'>
                <div id='feedback_loading_spinner'></div>
              </div>
            ) : error ? (
              <div id='feedback_error_message'>{errorMessage}</div>
            ) : (
              <>
                <form>
                  <div id='feedback-answers-section'>
                    <p id='feedback_blurb'>
                      We are always looking for ways to improve your experience. Please tell us what you think that
                      could make shopping at Dillard&apos;s even better.
                    </p>
                    {selectedTemplate &&
                      selectedTemplate.questions.map((qst) => {
                        return (
                          <FeedbackQuestionOptions
                            key={qst.questionId}
                            id={qst.questionId}
                            type={qst.type}
                            text={qst.text}
                            handleHover={handleHover}
                            hover={hover}
                            selectedState={selectedState}
                            handleSelectState={handleSelectState}
                            storeList={qst.storeList ? qst.storeList : undefined}
                            required={qst.required}
                            handleInput={handleInput}
                            handleSelectYoN={handleSelectYoN}
                            attemptedSubmit={attemptedSubmit}
                            siteFormat={siteFormat}
                            answersObj={answersObj}
                            options={qst?.questionOptions ? qst.questionOptions : undefined}
                          />
                        );
                      })}
                  </div>
                  <div id='feedback_buttons_section'>
                    <button className='btn btn-secondary btn-block' onClick={() => handleResetModal()}>
                      cancel
                    </button>
                    <button
                      className='btn btn-primary btn-block'
                      id='feedback_submit'
                      onClick={(e) => handleSubmitFeedback(e)}
                    >
                      submit
                    </button>
                  </div>
                </form>
              </>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default PopUpSurveyForm;
